import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as r } from "react";

function d() {
  var _r = r(null),
      _r2 = _slicedToArray(_r, 2),
      o = _r2[0],
      n = _r2[1];

  return {
    dropdownOpen: o,
    setDropdownOpen: n,
    handleToggle: function handleToggle(e) {
      return function () {
        n(function (l) {
          return e !== l ? e : null;
        });
      };
    },
    handleClose: function handleClose() {
      n(null);
    }
  };
}

export { d as useSecondaryNavDropdowns };